import { parseZonedDateTime } from '@rematter/common/dateTime';

import { ContainerRecord } from '../types/container';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { maybeParseZonedDateTime } from '~/shared/utils/dateTime';

export const containerDetailQueryAtom = createQueryAtomFactory(
  'trade.containerDetail',
  (params: { id: string }) => ({
    container: {
      __args: {
        id: params.id,
      },
      id: true,
      containerNumber: true,
      sealNumber: true,
      status: true,
      bookingId: true,
      booking: {
        id: true,
        documentNumber: true,
        status: true,
      },
      containerTypeId: true,
      containerType: {
        id: true,
        name: true,
      },
      loadId: true,
      load: {
        id: true,
        documentNumber: true,
        status: true,
      },
      facilityId: true,
      facility: {
        id: true,
        facilityName: true,
      },
      pickedUpAt: true,
      arrivedAtFacilityAt: true,
      loadedAt: true,
      departedFacilityAt: true,
      returnedToPortAt: true,
      shippedAt: true,
      organizationId: true,
      createdBy: true,
      createdByUser: {
        id: true,
        firstName: true,
        lastName: true,
      },
      updatedBy: true,
      updatedByUser: {
        id: true,
        firstName: true,
        lastName: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data): ContainerRecord | null => {
      if (!data || !data.container) {
        return null;
      }

      const container = data.container;

      return {
        id: container.id,
        containerNumber: container.containerNumber || null,
        sealNumber: container.sealNumber || null,
        status: container.status,
        bookingId: container.bookingId,
        booking: container.booking
          ? {
              id: container.booking.id,
              bookingNumber: container.booking.documentNumber,
            }
          : null,
        containerTypeId: container.containerTypeId,
        containerType: container.containerType || null,
        loadId: container.loadId || null,
        load: container.load
          ? {
              id: container.load.id,
              documentNumber: container.load.documentNumber,
            }
          : null,
        facilityId: container.facilityId || null,
        facility: container.facility || null,
        pickedUpAt: maybeParseZonedDateTime(container.pickedUpAt),
        arrivedAtFacilityAt: maybeParseZonedDateTime(
          container.arrivedAtFacilityAt,
        ),
        loadedAt: maybeParseZonedDateTime(container.loadedAt),
        departedFacilityAt: maybeParseZonedDateTime(
          container.departedFacilityAt,
        ),
        returnedToPortAt: maybeParseZonedDateTime(container.returnedToPortAt),
        shippedAt: maybeParseZonedDateTime(container.shippedAt),
        organizationId: container.organizationId,
        createdBy: container.createdBy,
        createdByUser: container.createdByUser || null,
        updatedBy: container.updatedBy,
        updatedByUser: container.updatedByUser || null,
        timestamps: {
          createdAt: parseZonedDateTime(container.timestamps.createdAt),
          updatedAt: parseZonedDateTime(container.timestamps.updatedAt),
        },
      };
    },
  },
);
